import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
        <Logo className="mb-6" />
        <h1 className="font-heading text-2xl font-bold">Nouveau mot de passe</h1>
        {!token ? (
          <p className="mt-3 text-red-600" data-testid="reset-no-token">Lien invalide. Veuillez refaire une demande de réinitialisation.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="password">Mot de passe</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} data-testid="reset-password-input" className="mt-1.5 h-11" placeholder="8 caractères minimum" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="reset-submit-button" className="w-full h-11 bg-blue-600 hover:bg-blue-700 rounded-xl">
              {loading ? "..." : "Réinitialiser"}
            </Button>
          </form>
        )}
        <p className="mt-6 text-sm text-slate-500 text-center"><Link to="/login" className="text-blue-600 hover:underline">Retour à la connexion</Link></p>
      </div>
    </div>
  );
}
